import { EbizioEvent, EbizioEventConfig, EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const couponsChangedHandler = ({ detail }: EbizioEvent) => {
  logger('Coupons Changed');
  console.log(detail);
};

export const couponsChangeddConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.COUPONS_CHANGED,
  handler: couponsChangedHandler,
};
